import React,{useRef, useState, useEffect} from "react";
import { Button} from "react-bootstrap";

class DoNowButton extends React.Component {

	
	
	constructor(props) {
		
		super(props);

		this.feedback = {
			"loading": "spinner-border spinner-border-sm text-info",
			"done": "ri-check-line text-success",
			"error": "ri-error-warning-line text-danger",
			"hide": "d-none",
		};
		
		this.fb = React.createRef();
		
		this.state = {
			variant: this.props.variant,
			icon: this.props.iconIdle,
			btnClassName: this.props.btnClassName,
			enabled:this.props?.enabled ?? 1
		};
		
	}

	async handleClick(e){
		
		if(!this.state.enabled)
			return;
		
		this.setLoading();

		Promise.resolve(this.props.onClick()).then((resp)=>{

			if(resp && resp.success){
				this.setDone();
				if(+this.props.finishTimeout){
					setTimeout(()=>{
						this.props.onFinish(resp.data);
					}, +this.props.finishTimeout);
					
				}
				else
					this.props.onFinish(resp.data);
				
				setTimeout(()=>{this.reset();}, 2000);
			}
			else
				this.setError();
			

			setTimeout(()=>{
				this.reset();
			}, this.props.finishTimeout+500);
			
		}).catch((e)=>{
			console.log(e);
			this.setError();
			
		});
	};
	setDone(){
		this.setState({...this.state, ...{icon:this.props.iconSuccess, text:this.props.textSuccess, enabled:1,  variant:this.props.variantSuccess, btnClassName:this.props.btnClassName+' working'}});
	}
	setError(){
		this.setState({...this.state, ...{icon:this.props.iconError, text:this.props.textError, enabled:0,  variant:this.props.variantError, btnClassName:this.props.btnClassName}});
	}
	setLoading(){
		this.setState({...this.state, ...{icon:this.props.iconLoading, text:this.props?.textLoading ?? this.props.text, enabled:0, btnClassName:this.props.btnClassName+' working'}});
	}
	reset(){
		this.setState({...this.state, ...{icon:this.props.iconIdle, enabled:1,  text:this.state.text, variant:this.props.variant, btnClassName:this.props.btnClassName}});
	}


	render() {
		return (
			<Button key={this.props.key} onClick={(e)=>{this.handleClick(e);}}  variant={this.state.variant} className={this.state.btnClassName}>
				{typeof this.state.icon == 'object' ? this.state.icon : <i ref={this.fb} className={this.state.icon}></i> }
				{this.state.text ? this.state.text : this.props.text}
			</Button>	
		);
	}
}

DoNowButton.defaultProps = {
	variant: "primary",
	variantSuccess: "outline-success",
	variantError: "outline-danger",
	text: "Do something",
	textSuccess: "Request sent",
	textError: "Request error",
	iconIdle: "d-none",
	iconLoading: "spinner-border spinner-border-sm text-info",
	iconSuccess: "ri-check-line",
	iconError: "ri-error-warning-line",
	finishTimeout: 0,
	btnClassName: "",
	onClick:(e)=>{return {success:true};}
}

export default DoNowButton;